<template>
  <div ref="wrapper" class="infinite-scroll-detector">
    <slot></slot>
  </div>
</template>

<script>
import { debounce } from 'lodash';
export default {
  name: 'InfiniteScrollDetector',
  props: {
    useFirstChild: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['load-more'],
  data: () => ({
    scrollHandler: null,
    scrollTarget: null,
  }),
  mounted() {
    if (this.useFirstChild) {
      this.scrollHandler = debounce(this.handleChildScroll, 100);
      this.scrollTarget = this.$refs.wrapper.firstChild;
      this.scrollTarget.addEventListener(
        'scroll',
        this.scrollHandler
      );
    } else {
      this.scrollHandler = debounce(this.handleGlobalScroll, 100);
      window.onscroll = this.scrollHandler;
    }
  },
  beforeDestroy() {
    if (this.scrollTarget && this.scrollHandler) {
      this.scrollTarget.removeEventListener(
        'scroll',
        this.scrollHandler
      );
    } else if (
      !this.useFirstChild &&
      window.onscroll === this.scrollHandler
    ) {
      window.onscroll = null;
    }
    if (this.scrollHandler) {
      this.scrollHandler.cancel();
    }
  },
  methods: {
    handleChildScroll() {
      const content = this.$refs.wrapper.firstChild;
      // Trigger when within 200px of bottom for more reliable detection
      const threshold = 200;
      const distanceFromBottom =
        content.scrollHeight -
        (content.scrollTop + content.clientHeight);

      if (distanceFromBottom <= threshold) {
        this.$emit('load-more');
      }
    },
    handleGlobalScroll() {
      // Trigger when within 200px of bottom for more reliable detection
      const threshold = 200;
      const distanceFromBottom =
        document.documentElement.offsetHeight -
        (document.documentElement.scrollTop + window.innerHeight);

      if (distanceFromBottom <= threshold) {
        this.$emit('load-more');
      }
    },
  },
};
</script>
